import React, { createContext, useContext } from 'react';
import PAGES_CONFIG from '../config/pages';

function buildFlatPages(pagesConfig) {
    const flat = [];
    pagesConfig.forEach(page => {
        const {index, children, ...rest} = page;
        if (page.content) {
            flat.push({ ...rest, navIndex: page.index, isParent: true });
        }
        if (page.children) {
            page.children
                .filter(c => c.type === 'anchor' && c.content)
                .forEach(child => {
                    const {index, children, ...rest} = child;
                    flat.push({ ...rest, navIndex: page.index, isParent: false });
                });
        }
    });
    return flat;
}

const flatPages = buildFlatPages(PAGES_CONFIG);
const contextValue = { pagesConfig: PAGES_CONFIG, flatPages };

const NavContext = createContext(contextValue);

export function NavConfigProvider({ children }) {
    return (
        <NavContext.Provider value={contextValue}>
            {children}
        </NavContext.Provider>
    );
}

export function useNavConfig() {
    return useContext(NavContext);
}
